<template>
    <div>
        <section class="section">
            <div class="row">
                <div style="text-align: center">
                    <img src="https://thewoodlandstaxattorney.com/static/images/logo-black.png" alt="">
                    
                </div>
                <div style="height: 50px;">
                    &nbsp;
                </div>
                
            </div>
            <div class="row">
                
                <div class="authClass" style="padding: 20px;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2); font-size: 13px;
        ">
                    <Login @showSignup="$store.state.authInfo.toggleLogin = false" v-if="$store.state.authInfo.toggleLogin"></Login>
                </div>
                
            </div>

        </section>    
    </div>
</template>

<script>
import Login from './Login.vue'

export default {
    data() {
        return {
            
        }
    },
    components: {
        Login
    },
    created() {
        //this.$store.dispatch('fetchCountries')

        if(this.$route.query.signup) {
            this.$store.state.authInfo.toggleLogin = false
        }

    }
}
</script>

<style scoped>
    .authClass {
        width: 400px; margin: 0 auto;
    }
    @media screen and (max-width: 600px) {
        .authClass {
            width: 100%;
            margin-top: 0;
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/Sessions/Login/Index.vue